import React, { useState } from 'react';
import MainCards from './MainCards';
import DetailedGuide from './DetailedGuide';
import StepDetail from './StepDetail';

const GuidedToolkit = () => {
  const [selectedCard, setSelectedCard] = useState(null);
  const [selectedStep, setSelectedStep] = useState(null);

  const handleCardClick = (id) => {
    setSelectedCard(id);
    setSelectedStep(null);
  };

  const handleStepSelect = (index) => {
    setSelectedStep(index);
  };

  const handleBack = () => {
    if (selectedStep !== null) {
      setSelectedStep(null);
    } else {
      setSelectedCard(null);
    }
  };

  if (!selectedCard) {
    return <MainCards onCardClick={handleCardClick} />;
  }

  if (selectedStep === null) {
    return <DetailedGuide selectedCard={selectedCard} onStepSelect={handleStepSelect} onBack={handleBack} />;
  }

  return <StepDetail selectedCard={selectedCard} selectedStep={selectedStep} onBack={handleBack} />;
};

export default GuidedToolkit;
